import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { useMutation } from '@/utils/api';

export interface CloudInitializeRequest {
  provider: string;
  org_account_id?: string;
  account_id?: string;
  tenant_id?: string;
  subscription_id?: string;
  org_id?: string;
  project_id?: string;
  deployment_type: string;
  external_id?: string;
}

export interface CloudInitializeResponse {
  username: string;
  password: string;
  template: string;
}

export default function useInitialize() {
  const axios = useAxios();

  return useMutation<
    CloudInitializeResponse,
    Error,
    CloudInitializeRequest,
    unknown
  >({
    mutationFn: async (data: CloudInitializeRequest) => {
      const response = axios.post<CloudInitializeResponse>(
        '/cloud/initialize',
        data
      );

      toast.promise(response, {
        loading: 'Initializing cloud integration...',
        success: 'Cloud integration initialized successfully',
        error: 'Failed to initialize cloud integration',
      });

      return (await response).data;
    },

    defaultErrorMessage: 'Failed to initialize cloud integration',
  });
}
